import { CustomerType } from './customer-type';

export class Customer {
  constructor(
    public hash?: string,
    public businessName?: string,
    public tradeName?: string,
    public tin?: string,
    public address?: string,
    public deliveryAddress?: string,
    public postCode?: string,
    public city?: string,
    public province?: string,
    public country?: string,
    public email?: string,
    public phone?: string,
    public contactPerson?: string,
    public contactPerson2?: string,
    public vat?: number,
    public customerType?: CustomerType
  ) { }

  clone() {
    return new Customer(
      this.hash,
      this.businessName,
      this.tradeName,
      this.tin,
      this.address,
      this.deliveryAddress,
      this.postCode,
      this.city,
      this.province,
      this.country,
      this.email,
      this.phone,
      this.contactPerson,
      this.contactPerson2,
      this.vat,
      this.customerType
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/customer.ts